//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class SearchInput extends React.Component {
  render() {
    const {
      className,
      value,
      placeholder,
      icon,
      onChange,
      onClickOpen,
      onBlur,
      t,
      isShort = false,
    } = this.props;
    const componentClasses = classNames(styles.SearchInput, {
      [className]: className,
      [styles.SearchInputShort]: isShort,
    });

    return (
      <div className={componentClasses} onClick={onClickOpen}>
        <input
          value={value}
          placeholder={placeholder}
          onChange={({ currentTarget: { value } }) => onChange(value)}
          className={styles.Input}
          ref={this.inputRef}
          onBlur={onBlur}
        />
        <img
          alt={t('accessibility_SearchProducts')}
          src={icon}
          className={styles.Icon}
        />
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(SearchInput);
